import React from 'react';

import _ from 'lodash';

import Field from './Field';
import InputTextField from './InputTextField';
import InputSelectField from './InputSelectField';
import InputSurveyQuestionResponse from './InputSurveyQuestionsResponse';

import {
  SurveyQuestionStructureType,
  SurveyQuestionStructureOption
} from '../../Entities/SurveyQuestion';

import './InputSurveyQuestionPrompt.scss';

class InputSurveyQuestionPrompt extends React.Component {
  constructor(props) {
    super(props);

    this.structureTypeOptions = [];
    for (let type in SurveyQuestionStructureType) {
      this.structureTypeOptions.push({
        value: SurveyQuestionStructureType[type].value,
        label: SurveyQuestionStructureType[type].label
      });
    }
  }


  _onInputChange(inputId) {
    return value => {
      const structure = _.cloneDeep(this.props.structure);
      structure.fields[inputId].value = value;

      this.props.onValueChange(structure);
    };
  }


  _onSurveyQuestionResponseChange(ident) {
    return value => {
      const responses = _.cloneDeep(this.props.structure.fields.options.value);
      if (value === null) {
        responses.splice(ident, 1);
      }
      else {
        responses[ident] = value;
      }

      this._onInputChange('options')(responses);
    };
  }


  handleAddSurveyQuestionResponseClick = () => {
    const responses = _.cloneDeep(this.props.structure.fields.options.value);
    responses.push(new SurveyQuestionStructureOption());
    this._onInputChange('options')(responses);
  }


  render() {
    const {
      structure,
      ident,
      inputId,
      editMode,
      structureDepth = 1
    } = this.props;

    const selectedResponseTypeHasDefinedResponses = structure.fields.type.value &&
      SurveyQuestionStructureType[structure.fields.type.value].hasDefinedResponses;

    const displayResponses = /*structure.fields.options.value.length > 0 ||*/
      selectedResponseTypeHasDefinedResponses;

    return (
      <div className="parkchirp--input-survey-question-prompt">
        <div className="parkchirp--input-survey-question-prompt--prompt-section">
          <div className="parkchirp--input-survey-question-prompt--prompt-input-container">
            <Field label="Question"
              id={`${inputId}--prompt`}
              layout="columns"
              containerClasses={[ 'parkchirp--input-survey-question-prompt--question-field' ]}>
              <InputTextField inputId={`${inputId}--prompt`}
                value={structure.fields.prompt.value}
                onChange={this._onInputChange('prompt')}
                editMode={editMode}
              />
            </Field>
          </div>
          <div className="parkchirp--input-survey-question-prompt--response-type-input-container">
            <Field label="Response Type"
              id={`${inputId}--type`}
              layout="columns">
              <InputSelectField inputId={`${inputId}--type`}
                options={[ { value: null, label: '' }, ...this.structureTypeOptions ]}
                value={structure.fields.type.value}
                onChange={this._onInputChange('type')}
                editMode={editMode}
              />
            </Field>
          </div>
        </div>
        {(displayResponses) &&
          <div className="parkchirp--input-survey-question-prompt--response-section">
            <Field label="Responses"
              layout="columns"
              containerClasses={['parkchirp--input-survey-question-prompt--response-field']}>
              {(structure.fields.options.value.length > 0) &&
                <div className="parkchirp--input-survey-question-prompt--response-list-container">
                  {structure.fields.options.value.map((response, ident) => {
                    return (
                      <InputSurveyQuestionResponse inputId={inputId}
                        key={ident}
                        ident={ident}
                        response={response}
                        disableFollowUpQuestion={structureDepth > 1}
                        onValueChange={this._onSurveyQuestionResponseChange(ident)}
                        editMode={editMode}
                      />
                    );
                  })}
                </div>
              }
              {(editMode && selectedResponseTypeHasDefinedResponses) &&
                <div className="parkchirp--input-survey-question-prompt--action-container">
                  <button type="button"
                    className="parkchirp--button-as-link"
                    onClick={this.handleAddSurveyQuestionResponseClick}>
                    Add Response
                  </button>
                </div>
              }
            </Field>
          </div>
        }
      </div>
    );
  }
}
export default InputSurveyQuestionPrompt;
